const invertedMessages = {
  'Column navigation': 'certs.label.columnNavigation',
  'Go to column {column}': 'certs.description.goToColumn',
  'Scroll columns left': 'certs.label.scrollColumnsLeft',
  'Scroll columns right': 'certs.label.scrollColumnsRight',
};

export default invertedMessages;
